import { apiRequest } from './http';

export interface PurchasePayload {
    plan_name: string;
    price: number;
}

export interface PurchaseResponse {
    message?: string;
    data?: any;
    [key: string]: any;
}

export const purchaseSubscription = async (
    token: string,
    payload: PurchasePayload
): Promise<PurchaseResponse> => {
    return apiRequest<PurchaseResponse>({
        endpoint: '/subscriptions/purchase',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
    });
};

export interface UnsubscribePayload {
    first_name: string;
    last_name: string;
    email: string;
    iban_last_5: string;
}

export interface UnsubscribeResponse {
    message?: string;
    data?: any;
}

export const unsubscribe = async (
    payload: UnsubscribePayload
): Promise<UnsubscribeResponse> => {
    return apiRequest<UnsubscribeResponse>({
        endpoint: '/subscriptions/unsubscribe',
        method: 'POST',
        body: JSON.stringify(payload),
    });
};
